import { render, staticRenderFns } from "./TopicMindWrapper.vue?vue&type=template&id=316acfac&scoped=true&"
import script from "./TopicMindWrapper.vue?vue&type=script&lang=js&"
export * from "./TopicMindWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TopicMindWrapper.vue?vue&type=style&index=0&id=316acfac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316acfac",
  null
  
)

export default component.exports